import request from '@/utils/request'

/**
 * 管理员登录
 * @param {string} account - 账号
 * @param {string} password - 密码
 * @param {string} captchaVerification - AJ-Captcha 二次校验加密串
 */
export function adminLogin(account, password, type = 'admin', captchaVerification = '') {
  return request({
    url: '/manage/auth/login',
    method: 'post',
    data: { account, password, type, captchaVerification }
  })
}

/** 管理员修改密码 */
export function changePwd(data) {
  return request({
    url: '/manage/auth/password/change',
    method: 'post',
    data
  })
}
